<template>
  <div class="custom-container-filter">
    <div class="col-6 py-1 custom-container-filter-info">
      <custom-imput
        icon="fa fa-search orange-icon"
        left-icon
        placeholder="Escriba Nombre o Usuario"
      />
    </div>
    <div class="col-4 py-1 custom-container-filter-info">
      <custom-drop-down
        class="custom-drop-down"
        :clearable="false"
        fieldkey="id"
        fieldname="description"
        placeholder="Seleccione Rol"
      />
    </div>
    <div class="col-1 py-1 custom-container-filter-button">
      <action-button
        class="fr px-4 custom-search-button"
        text="Buscar"
        variant="success"
      />
    </div>
  </div>
</template>

<script>
import ActionButton from '@/components/common/ActionButton';
import CustomDropDown from '@/components/common/form/CustomDropDown';
import CustomImput from '@/components/common/form/CustomInput';

export default {
  name: 'FilterList',
  components: {
    ActionButton,
    CustomDropDown,
    CustomImput,
  },
  props: {
    userName: {
      type: String,
      required: true,
    },
    rolName: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped>
.custom-container-filter {
  float: left;
  width: 100%;
}

.custom-container-filter-info {
  float: left;
  width: 100%;
}

.custom-container-filter-button {
  float: right;
  width: 100%;
}
</style>
